<ng-container>
  <ng-container>
    @if (agreement) {
      <div class="contract-details">
        <div class="details" [ngClass]="{'disabled': disableAgreement()}">
          <div class="details__info">
            <div class="details__list">
              @for (attribute of attributes; track attribute) {
                <div
                  class="details__list-item {{attribute.attribute}}"
                  [ngClass]="attribute.attribute === 'contractNumber' ? 'hidden' : ''">
                  <div class="details__list-item--title">
                    {{ attribute.label | translate }}
                    @if (attribute.tooltip) {
                      <app-tooltip
                        link="icon"
                        text="{{ attribute.tooltip | translate }}">
                      </app-tooltip>
                    }
                  </div>
                  <div class="details__list-item--data">
                    {{ getAttribute(attribute.attribute, attribute.nestedAttribute ?? '') }}
                  </div>
                </div>
              }
            </div>
          </div>
          <app-access-control [notForViewer]="true">
            <ng-container ngProjectAs="[slot][nonViewerContent]">
              @if (disableAgreement()) {
                <div class="details__buttons">
                  <span class="new-quote-desc">{{ 'my-contracts.start-new-quote' | translate }}</span>
                </div>
              } @else {
                <div class="details__buttons">
                  @if (selectableEquipment) {
                    <span class="equipment-buttons">
                      @if (!equipmentSelectionInProgress) {
                        <button
                          type="button"
                          class="button button--primary action-button"
                          [attr.data-test]="'button-selectFunctionalLocation'"
                          [disabled]="disableSelectEquipmentButton()"
                          (click)="selectFlWithEndOfSupportCheck()">
                          <span>{{ 'my-equipment.select-equipment' | translate }}</span>
                        </button>
                      } @else {
                        <div class="spinner">
                          <div class="loading-animation"></div>
                        </div>
                      }
                      @if (isUserSparePartsViewer()) {
                        <div class="additional-options">
                          <a class="spare-parts-viewer"
                            (click)="openSparePartsViewer()"
                            [attr.data-test]="'link-sparePartsViewer'">
                            <span class="icon-arrow-long-right"></span>
                            <span>{{ 'my-equipment.select-spare-parts-viewer' | translate }}</span>
                          </a>
                        </div>
                      }
                    </span>
                  }
                </div>
              }
            </ng-container>
          </app-access-control>
        </div>
        <app-my-equipment-components
          [agreement]="agreement">
        </app-my-equipment-components>
        @if (isAddQuoteModalOpen) {
          <app-modal
            [id]="'add-quote-modal'"
            [open]="isAddQuoteModalOpen"
            [title]="'my-contracts.add-quote-modal-title' | translate"
            (crossClick)="isAddQuoteModalOpen = false"
            (outsideClick)="isAddQuoteModalOpen = false">
            <ng-container ngProjectAs="[slot][body]">
              <app-add-quote-modal
                [flNumber]="agreement.attributes?.functionalLocation"
                [materialNumber]="agreement.attributes?.materialNumber"
                [soldToIdFromParams]="soldToIdFromParams"
                [modalitiesAndMaterialNumbers]="modalitiesAndMaterialNumbers"
                [productSku]="productSku">
              </app-add-quote-modal>
            </ng-container>
          </app-modal>
        }
      </div>
    }
  </ng-container>
</ng-container>
<app-modal-confirm
  class="modal-confirm"
  [type]="iconType.WARNING"
  modalTitle="{{ 'equipment-selection.you-have-items-in-cart' | translate }}"
  notifyText="{{ 'equipment-selection.change-equipment-or-create-cart-info-text' | translate }}"
  secondaryBtnText="{{ 'equipment-selection.new-cart' | translate }}"
  primaryBtnText="{{ 'equipment-selection.change-equipment' | translate }}"
  [showModalConfirm]="showModalChangeEquipmentOrCreateNewCart"
  (closeModalConfirm)="closeModalChangeEquipmentOrCreateNewCart()"
  (secondaryActionConfirm)="createNewCartForEquipment()"
  (primaryActionConfirm)="changeEquipmentForCurrentCart()">
</app-modal-confirm>
<app-modal-select-sold-to-account
  [isEquipmentSelectionPage]="true"
  [showModalConfirm]="showModalSelectSoldToAccount"
  (closeModalConfirm)="showModalSelectSoldToAccount = false"
  (primaryActionConfirm)="selectedSoldToAccountFromModal($event)"
  [currentCart]=getCurrentCart()
  [isMissingSoldTo]="this.showModalBecauseMissingSoldTo"
  [soldToAccounts]="soldToAccounts"
  />
<app-modal-eos-equipment
  [showModalEosEquipment]="showModalEosEquipment"
  (closeModalConfirm)="showModalEosEquipment = $event"
  (primaryActionConfirm)="showModalEosEquipment = $event; selectSoldToAccountAfterSelectedFl()"
  />

